import Cookies from 'js-cookie'
const TokenKey = 'JWT-TH-Monitor-Token'
const UserLanguage = 'user-language'
const Theme = 'monitor-theme'
// 请求token
function getToken() {
  return Cookies.get(TokenKey)
}

function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 360 * 50 })
}

function removeToken() {
  return Cookies.remove(TokenKey)
}
// 用户语言设置
function getUserLanguage() {
  return (Cookies.get(UserLanguage) || 'en')
}
function setUserLanguage(lang) {
  return Cookies.set(UserLanguage, lang, { expires: 360 * 50 })
}
function removeUserLanguage() {
  return Cookies.remove(UserLanguage)
}

// 用户主题设置
function getTheme() {
  return Cookies.get(Theme)
}
function setTheme(theme) {
  return Cookies.set(Theme, theme, { expires: 360 * 50 })
}
function removeTheme() {
  return Cookies.remove(Theme)
}
export {
  getToken,
  setToken,
  removeToken,
  getUserLanguage,
  setUserLanguage,
  removeUserLanguage,
  setTheme,
  getTheme,
  removeTheme

}
